import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchGlobalSearchResults, fetchSearchFilterOptions, GlobalSearchParams } from "../../services/GlobalSearchService";

export const fetchGlobalSearchAsync = createAsyncThunk(
  "globalSearch/fetchResults",
  async (params: GlobalSearchParams, { rejectWithValue }) => {
    try {
      const response = await fetchGlobalSearchResults(params);
      return response;
    } catch (error: unknown) {
      const err = error as { response?: { data?: string }; message?: string };
      return rejectWithValue(err.response?.data || err.message || "Search failed");
    }
  }
);

export const fetchSearchFiltersAsync = createAsyncThunk(
  "globalSearch/fetchFilters",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchSearchFilterOptions();
      return response;
    } catch (error: unknown) {
      const err = error as { response?: { data?: string }; message?: string };
      return rejectWithValue(err.response?.data || err.message || "Failed to load filters");
    }
  }
);
